import { addTelemetryError } from '../domain/telemetry';
import { monitor } from '../tools/monitor';
import { isExperimentalFeatureEnabled, isSimulationActive } from '../domain/configuration';
import { newRetryState, sendWithRetryStrategy } from './sendWithRetryStrategy';
export function createHttpRequest(endpointBuilder, bytesLimit, reportError, toPrimaryEndpoint) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            if (!isExperimentalFeatureEnabled('retry')) {
                fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload);
            }
            else {
                sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, toPrimaryEndpoint, reportError);
            }
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            if (isExperimentalFeatureEnabled('retry') &&
                endpointBuilder.endpointType !== 'sessionReplay' &&
                toPrimaryEndpoint &&
                isSimulationActive()) {
                return;
            }
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount;
    var url = endpointBuilder.build();
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var isQueued = navigator.sendBeacon(url, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    sendXHR(url, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addTelemetryError(e);
    }
}
export function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount;
    var url = endpointBuilder.build();
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        fetch(url, { method: 'POST', body: data, keepalive: true }).then(monitor(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status }); }), monitor(function () {
            // failed to queue the request
            sendXHR(url, data, onResponse);
        }));
    }
    else {
        sendXHR(url, data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.send(data);
    request.addEventListener('loadend', monitor(function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }));
}
//# sourceMappingURL=httpRequest.js.map